import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {NgControl} from '@angular/forms';

export enum SplitterType {
  AIN,
  SSN,
  ZIP,
  PHONE,
}

@Directive({
    selector: '[appNumericSplitter]',
    standalone: false
})
export class NumberSplitterDirective {
  @Input() splitterType: SplitterType = SplitterType.AIN;

  constructor(private el: ElementRef, private ngControl: NgControl) {
  }

  getTemplate(): number[] {
    switch (this.splitterType) {
      case SplitterType.AIN:
        return [10, 4, 8];
      case SplitterType.SSN:
        return [9, 3, 6];
      case SplitterType.ZIP:
        return [9, 5];
      case SplitterType.PHONE:
        return [10, 3, 7];
    }
  }

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    value = value.replace(/\D/g, '');
    const template = this.getTemplate();

    if (value.length > template[0]) {
      value = value.slice(0, template[0]);
    }

    for (let i = 1; i < template.length; ++i) {
      if (value.length > template[i]) {
        value = value.slice(0, template[i]) + '-' + value.slice(template[i]);
      }
    }

    this.ngControl.control?.setValue(value, { emitEvent: false });
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const value = this.el.nativeElement.value;
    const cursorPosition = this.el.nativeElement.selectionStart;

    if ((event.key === 'Backspace' || event.key === 'Delete') && (value[cursorPosition - 1] === '-' || value[cursorPosition] === '-')) {
      event.preventDefault();

      const newPosition = event.key === 'Backspace' ? cursorPosition - 2 : cursorPosition;
      const beforeDash = value.slice(0, newPosition);
      const afterDash = value.slice(cursorPosition + 1);
      this.el.nativeElement.value = beforeDash + afterDash;
      this.el.nativeElement.setSelectionRange(newPosition, newPosition);
    }
  }
}
